import ApiCaller from './ApiCaller';
import baseAjaxConfig, { headers } from './BaseAjaxConfig';

export const GET_PRODUCT_SUMMARY_REQUEST = 'GET_PRODUCT_SUMMARY_REQUEST';
export const GET_PRODUCT_SUMMARY_SUCCESS = 'GET_PRODUCT_SUMMARY_SUCCESS';
export const GET_PRODUCT_SUMMARY_ERROR = 'GET_PRODUCT_SUMMARY_ERROR';

export function getProductSummaryAction(products) {
	return { type: GET_PRODUCT_SUMMARY_REQUEST, products };
}

export function getProductSummarySuccessAction(data, products) {
	return { type: GET_PRODUCT_SUMMARY_SUCCESS, data, products };
}

export function getProductSummaryErrorAction(error, products) {
	return { type: GET_PRODUCT_SUMMARY_ERROR, error, products };
}

// TODO - use generator to get batches
export function fetchProductSummaryAction(
	products,
	locationContext,
	dgTackingParams,
	pathname = '/api/3/product/summary',
	batches = [20, 20, 20, 20],
	requestHeaders = {}
) {
	return (dispatch, getState) => {
		if (!products || !products.length) {
			return null;
		}
		dispatch(getProductSummaryAction(products));

		const makeApiCall = products => {
			const payload = {
				requestContext: { products }
			};
			locationContext && (payload.locationContext = locationContext);
			dgTackingParams && (payload.requestContext.dgTackingParams = dgTackingParams);
			return ApiCaller.post(
				Object.assign({}, baseAjaxConfig, {
					pathname: pathname,
					action: GET_PRODUCT_SUMMARY_REQUEST,
					headers: Object.assign({}, headers, requestHeaders)
				}),
				payload
			).then(
				json => dispatch(getProductSummarySuccessAction(json['RESPONSE'], products)),
				err => {
					dispatch(getProductSummaryErrorAction(err, products));
					return Promise.reject(err);
				}
			);
		};

		function getProductBatches(products, batches) {
			let lastBatch = 0;
			const productBatches = [];

			batches.forEach(batch => {
				productBatches.push(products.slice(lastBatch, lastBatch + batch));
				lastBatch += batch;
			});

			return productBatches.filter(x => x.length);
		}

		// code to make product summary call in batches of 10 followed by 10, 20, 20
		const productBatches = getProductBatches(products, batches);

		let p;
		return Promise.all(
			productBatches.map(products => {
				if (!p) {
					p = makeApiCall(products);
					return p;
				}
				return p.then(makeApiCall.bind(null, products));
			})
		);
	};
}
